export const SET_LANG = 'SET_LANG'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js